import { List, Map } from "immutable";

import { Dispatch } from "common/types";

import SessionReport from "seneca-common/features/session/models/SessionReport";
import {
  applyCompleteSessionEventToSectionStat,
  receiveReconciledSectionStudyStats,
  SectionStat,
  transformServerSectionStat
} from "seneca-common/features/stats/state";

export const reconcileSectionStudyStats = (
  sessionReports: List<SessionReport>,
  sectionStats: List<SectionStat>,
  reconciledProficiencies: Map<string, number>,
  dispatch: Dispatch
) => {
  const reconciledStudyStats = sectionStats
    .map(transformServerSectionStat)
    .map(sectionStat => {
      const relevantSessionFinishedEvents =
        getRelevantSessionFinishedEventsForSection(
          sectionStat.sectionId!,
          sessionReports
        );

      let newStat = relevantSessionFinishedEvents.reduce((newStat, event) => {
        return applyCompleteSessionEventToSectionStat(newStat, event!, {
          logUpdateSpacingWarnings: false
        });
      }, sectionStat);

      newStat = newStat.set(
        "proficiency",
        reconciledProficiencies.get(sectionStat.sectionId!)
      );

      return newStat;
    });
  dispatch(receiveReconciledSectionStudyStats(reconciledStudyStats));
};

const getRelevantSessionFinishedEventsForSection = (
  sectionId: string,
  sessionReports: List<SessionReport>
) => {
  return sessionReports
    .filter(report => report.session!.sectionIds.contains(sectionId))
    .map(report => report.session);
};
